export default __webpack_public_path__ + "static/media/saree2.b9bcce2c.jpg";